import { usePlaylistStore } from "@/stores/playlist.js";

// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = { 38: 1, 40: 1, 32: 1, 33: 1, 34: 1, 35: 1, 36: 1 };

function preventDefaultMouse(e) {
    if (e.srcElement.localName === "input") {
        
    } else if (e.srcElement.localName === "textarea") {
        const element = e.srcElement;
        if (element.scrollHeight < element.clientHeight) {
            e.preventDefault();
            return false;
        }
    } else {
        e.preventDefault();
        return false;
    }
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        if (e.srcElement.localName !== "input" && e.srcElement.localName !== "textarea") {
            e.preventDefault();
            return false;
        }
    }
}

function preventTouch(e) {
    if (!e.target.classList.contains("allow-touch")) {
        if (e.srcElement.localName === "input" || e.srcElement.localName === "textarea") {
            const element = e.srcElement;
            if (element.scrollHeight < element.clientHeight) {
                e.preventDefault();
                return false;
            }
        } else {
            e.preventDefault();
            return false;
        }
    }
}

// modern Chrome requires { passive: false } when adding event
let supportsPassive = false;
try {
    window.addEventListener(
        "test",
        null,
        Object.defineProperty({}, "passive", {
            get: function () {
                supportsPassive = true;
            },
        })
    );
} catch (e) {}

const wheelOpt = supportsPassive ? { passive: false } : false;
const wheelEvent =
    "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

// call this to Disable
export function disableScroll(strElem = "#mobileContainer") {
    const plStore = usePlaylistStore();
    plStore.setScrollDisabled(true);
    const elem = document.querySelector(strElem);
    elem.addEventListener("DOMMouseScroll", preventDefaultMouse, false); // older FF
    elem.addEventListener(wheelEvent, preventDefaultMouse, wheelOpt); // modern desktop
    elem.addEventListener("touchmove", preventTouch, wheelOpt); // mobile
    elem.addEventListener("keydown", preventDefaultForScrollKeys, false);

    const container = document.getElementById('mobileContainer');
    setTimeout(() => {container.style.overflow = 'hidden';},250);
}

// call this to Enable
export function enableScroll(strElem = "#mobileContainer") {
    const plStore = usePlaylistStore();
    plStore.setScrollDisabled(false);
    const elem = document.querySelector(strElem);
    elem.removeEventListener("DOMMouseScroll", preventDefaultMouse, false);
    elem.removeEventListener(wheelEvent, preventDefaultMouse, wheelOpt);
    elem.removeEventListener("touchmove", preventTouch, wheelOpt);
    elem.removeEventListener("keydown", preventDefaultForScrollKeys, false);

    const container = document.getElementById('mobileContainer');
    container.style.overflow = 'scroll';
}

function smoothScrollTo(element, target, duration) {
    const start = element.scrollTop;
    const change = target - start;
    let currentTime = 0;
    const increment = 20;

    const animateScroll = function () {
        currentTime += increment;
        const val = Math.easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
            requestAnimationFrame(animateScroll);
        }
    };

    animateScroll();
}

Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
};

export function scrollToSlide(intSlide) {
    const plStore = usePlaylistStore();
    if (isNaN(intSlide)) {
        console.error("Current Index is Not a Number");
        return false;
    }

    const slide = document.querySelector(
        "[data-slide-index='" + intSlide + "']"
    );

    //if (slide) slide.parentElement.scrollTop = slide.offsetTop;

    if (!slide) return;

    const parent = slide.parentElement;

    // Calculate the maximum scrollTop value to ensure we don't scroll past the last slide
    const maxScrollTop = parent.scrollHeight - parent.clientHeight;

    let targetScrollTop = slide.offsetTop;

    // Ensure the target scroll position doesn't exceed the maximum scroll position
    if (targetScrollTop > maxScrollTop) {
        targetScrollTop = maxScrollTop;
    }

    plStore.targetScrollTop = targetScrollTop;

    // Smooth scrolling to the calculated target scroll position
    smoothScrollTo(parent, targetScrollTop, 500);
}
